import DropzoneController from '@kanety/stimulus-dropzone';

// Connects to data-controller="dropzone"
export default class extends DropzoneController {
  dropped(e: CustomEvent) {
    if(e.detail.files.length == 1 && e.detail.files[0].type !== 'application/pdf') {
      e.preventDefault();
      ((this.element as HTMLElement).closest('form') as HTMLFormElement).reset();

      return alert('PDFファイルをドラッグしてください')
    }
  }
}
